import { objectWithoutProperties as _objectWithoutProperties } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}
var SuccessCheck = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "26",
    height: "26"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 13C0 5.82 5.819 0 13 0c7.18 0 13 5.819 13 13 0 7.18-5.819 13-13 13-7.18 0-13-5.819-13-13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F55700",
    d: "M4 13a9 9 0 019-9 9 9 0 019 9 9 9 0 01-9 9 9 9 0 01-9-9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M9.247 13.557a.8.8 0 00-1.19 1.071l1.941 2.155a.905.905 0 001.272.066l6.613-5.954a.8.8 0 10-1.07-1.19l-6.094 5.487-1.472-1.635z"
  })));
});

export default SuccessCheck;
//# sourceMappingURL=success-check.svg.js.map
